import {APIClient} from "../base";
import {PaginationInterface} from "../../../interfaces/PaginationInterface";

const ProductApi = {
    getAll: async (pagination: PaginationInterface) => await APIClient.get('/product', pagination),
    getDetail: async (id: number|string|any) => await APIClient.get('/product/' + id, {}),
    update: async (id: number|string|any, data: { inventory_netWeight?: number | null }) =>
        await APIClient.update('/product/' + id, data),
}

export default ProductApi;